import React, {useEffect, useRef} from "react";
import Api from "../../fetchs/Api";
import Modals from "../../componentesHTML/componentesSecundarios/Modals";
import {useStoreGlobal} from '../../../stores/Global'
import {useShallow} from 'zustand/react/shallow'
import Highlighter from "react-highlight-words"
import ApiInsertarBusquedaClic from "../../fetchs/ApiInsertarBusquedaClic";
import latinize from 'latinize';
import ApiInsertarBusqueda from "../../fetchs/ApiInsertarBusqueda";
function BuscadorTabulados(parametros){
  const _updateTotalDatos= useStoreGlobal(useShallow((state) => state._updateTotalDatos));
  const rutanRef= useRef([]);
  let var_ingles = "es";
  if (window.location.href.indexOf("en.") > -1) {
      var_ingles = "en";
  }
  let idioma = var_ingles==="es"?"Fecha de última actualización: ":"Date for last update: ";
  const registradatos = ((TITULO,URL,metodoBusqueda) => {
    TITULO= TITULO.replace(/['°|@_=¿?¡!:/<>~()&%#*;+-.,?^${}[(\)]|[\]\\]/g, " ");   
      let metodo="";
      if (metodoBusqueda === 1){
        metodo="Todas las palabras";
      }
      if (metodoBusqueda === 2){
        metodo="Cualquier palabra";
      }
      if (metodoBusqueda === 3){
        metodo="Frase completa";
      }
      const param = {
        CONTADOR_CLICK: 1,
        ID_COLECCION: "8",
        IP_USER: "",
        Metodo: metodo,
        Palabra_relacionada: "",
        TEXTO_BUSCADO: parametros.textoBusqueda,
        TITULO_URL: TITULO.replace(/['°|@_=~¿?¡!:/<>()&%#*;+-.,?^${}[(\)]|[\]\\]/g, " "),
        URL: URL
      };
    ApiInsertarBusquedaClic(param);
  });
    const highlightTexto = (textoSuggest) => {
        let campo = document.getElementById('inputQ').value.trim();
        campo= campo.replace(/['°|@_=¿?¡!:/<>~()&%#*;+-.,?^${}[(\)]|[\]\\]/g, " ");
        campo= trataTextoHigh(campo);
        let textInputAux = campo.split(" ");
        let concatena= [];
        for (const word of textInputAux) {
          concatena.push(`${word}`); 
        }
        return  (
            <Highlighter
                    highlightClassName="highlight"
                    searchWords={concatena}
                    autoEscape={true}
                    textToHighlight= {textoSuggest }
                    sanitize={sanitizeText}
                    caseSensitive={false}
                /> 
        );
    }
    const sanitizeText = (text) => {
      return latinize(text);
    };
    function trataTextoHigh(texto) { 
    let articulos = [
        "insert", "drop", "delete", "truncate", ";", "--", "xp_", "in", "table", "exec", "of", "with", "the", "from", "al", "as", "is", "can", " also ", " already ", " more ", " you ", " others ", " and ", " but ", " between ", " are ", " than ", "one", "no", "your", "it",
        "a", "e", "i", "o", "u", "adónde", "al", "algo", "alguien", "alguna", "algunas", "alguno", "algunos", "ante", "aquel", "aquél",
        "aquella", "aquélla", "aquellas", "aquéllas", "aquello", "aquellos", "aquéllos", "bajo", "cabe",
        "como", "cómo", "con", "conmigo", "consigo", "contigo", "contra", "cual", "cuál", "cuales", "cuáles",
        "cualesquiera", "cualquiera", "cuando", "cuándo", "cuanta", "cuánta", "cuantas", "cuántas", "cuánto",
        "cuantos", "cuántos", "cuya", "cuyas", "cuyo", "cuyos", "de", "del", "demás", "desde", "donde", "dónde",
        "durante", "el", "él", "ella", "ellas", "ello", "ellos", "en", "entre", "es", "esa", "ésa", "esas", "ésas", "ese",
        "ése", "eso", "esos", "ésos", "esotra", "esotro", "esta", "está", "ésta", "estas", "éstas", "este", "éste",
        "esto", "estos", "éstos", "hacia", "hasta", "la", "las", "le", "les", "lo", "los", "más", "me", "mediante",
        "mí", "mía", "mías", "mío", "míos", "misma", "mismas", "mismo", "mismos", "mucha", "muchas", "mucho",
        "muchos", "nada", "nadie", "ninguna", "ningunas", "ninguno", "ningunos", "no", "nos", "nosotras",
        "nosotros", "nuestra", "nuestras", "nuestro", "nuestros", "os", "otra", "otras", "otro", "otros",
        "para", "pero", "poca", "pocas", "poco", "pocos", "por", "puede", "que", "qué", "quien", "quién", "quienes", "quiénes",
        "se", "según", "sí", "sin", "so", "sobre", "son", "su", "suya", "suyas", "suyo", "suyos", "también", "tanta",
        "tantas", "tanto", "tantos", "te", "ti", "toda", "todas", "todo", "todos", "tras", "tú", "tuya", "tuyas", "tuyo",
        "tuyos", "última", "últimas", "último", "últimos", "un", "una", "unas", "uno", "unos", "usted", "ustedes", "varias",
        "varios", "versus", "vía", "vos", "vosotras", "vosotros", "vuestra", "vuestras", "vuestro", "vuestros", "y", "ya", "yo"
    ];
    let parrafo = (texto.replace(/\./g, '').trim());
    let palabras = parrafo.split(/\s/);
    for (let p = 0; p < palabras.length; p++) {
        for (let a = 0; a < articulos.length; a++) {
            if (articulos[a] == palabras[p].toLowerCase()) {
                palabras[p] = '';
                break;
            }
        }
    }
    let newTexto = palabras.join(' ');
    let textoTratado = newTexto.replace(/([\ \t]+(?=[\ \t])|^\s+|\s+$)/g, '');
    return textoTratado;
    }
    function fecha(fecha){
      let fec = fecha.split("T");
      return fec[0];
    }
  if (parametros.coleccionTodo != "Todo") {
    let apiData = [];
    let metodo="";
      if (parametros.metodoBusqueda === 1){
        metodo="Todas las palabras";
      }
      if (parametros.metodoBusqueda === 2){
        metodo="Cualquier palabra";
      }
      if (parametros.metodoBusqueda === 3){
        metodo="Frase completa";
      }
    const param = {
      busqueda: parametros.textoBusqueda,
      busquedaCiencia: "",
      paginaInicio: parametros.pageInicial,
      paginaFin: parametros.pageFin,
      idioma: var_ingles,
      filtrobusqueda: parametros.camposBuscador,
      orderby: parametros.camposOrden,
      orderbyAscDesc: parametros.ordenamiento,
      metodoBusqueda: parametros.metodoBusqueda
    };
    apiData = Api("/app/api/buscadorcore/v1/busquedaTabulados/", param)
    function RegistraBus(data){
          if(data.length > 0)
            ApiInsertarBusqueda(parametros.textoBusqueda ,"21", data[0].TOTAL, metodo);
          else
            ApiInsertarBusqueda(parametros.textoBusqueda ,"21", 0, metodo);
        }
    useEffect(() => {
      if(parametros.coleccionTodo != "Todo"){
        if (!apiData.loading){
          RegistraBus(apiData.data)
        }
        if(apiData.data.length > 0) {
          apiData.data.forEach(element => {
            if (rutanRef.current[element.ID] != null ) {
              document.getElementById("nivel1-0-" + element.ID).innerHTML=element.PROYECTO_TEMA;
            }
          });
          document.getElementById('resultados').innerHTML= apiData.data[0].TOTAL;
          _updateTotalDatos({totalDatos:apiData.data[0].TOTAL});
        }else{
          _updateTotalDatos({totalDatos:0});
          document.getElementById('resultados').innerHTML= 0;
        }
      }
      },[apiData.data]);
    return(
        <>
        {apiData.loading? <Modals />:
          !apiData.loading && apiData.data?.map((datos,i) => (
          <div className = "col-lg-12 todo" key={"coleccionBuscadorTabulados-" + i} style={{marginBottom:"26px"}} id={"resultadoGeneral-" + i}>
                <div className="col-lg-9 resaltar todoResponsivo " id={"tituloTodo-" + i} style={{display: "inline-flex"}}>
                  <div className="col-lg-10" id={"snippet_titulo-"+ i} style={{textAlign: "justify", display: "inline-flex"}}>
                  {
                    datos.IMAGEN== null || datos.IMAGEN=== "" ? (
                      <a target="_blank" href={datos.URL} id={"snippet_row-"+ i}> 
                        <div onClick={() =>registradatos(datos.TITULO,datos.URL,parametros.metodoBusqueda)} id={"gadget-" + i}>
                          {highlightTexto(datos.TITULO)}
                        </div>
                      </a>
                    ): (
                      <span className="color-tabulador" id={"snippet_row-" + i}>
                        {highlightTexto(datos.TITULO)} 
                      </span>
                    )
                  }
                  </div>
                  <div className="col-xs-12 col-md-3 tabulados" style={{textAlign:"center"}} id={"snippet_area-" + i}>
                    <span className=" col-xs-12 col-md-12 color-tabulador" id={"snippet_area-1-" + i}>
                    {datos.AREAGEOGRAFICA}
                    </span>
                  </div>
                  <div className="col-xs-12 col-sm-2" id={"snippet_column_periodo-" + i}>
                    <span className=" col-xs-12 col-sm-12 color-tabulador" id={"snippet_row-periodo-" + i}>
                    {datos.PERIODO}
                    </span>
                  </div>
                  {
                    datos.IMAGEN== null || datos.IMAGEN=== "" ? "": (
                      <div style={{paddingRight: "0px", textAlignLast:"right"}} id={"snippet_column_descarga-" + i}>
                        <a target="_blank" href={datos.URL} id={"snippet_row-tag-" + i} onClick={() =>registradatos(datos.TITULO,datos.URL,parametros.metodoBusqueda)}>
                          <img src={datos.IMAGEN}  id={"snippet_row-tag-1-" + i} alt="" /> 
                        </a>
                        <small className=" col-xs-12 col-sm-12" id={"snippet_row-tag-2-" + i}>
                          {datos.TAMANO}
                        </small>
                      </div>
                    )
                  }
                </div>
                <div className="col-xs-12 col-sm-7" style={{paddingBottom: "10px"}} id={"nivel1-" + i}>
                  <div style={{textAlign: "justify"}} id={"nivel1-0-" + i} ref={(el) => (rutanRef.current[i] = el)}>  
                  </div>
                </div>
                <div className="col-xs-12" id={"nivelT3-" + i}>
                  <div className="col-xs-9 formato_fecha" id={"nivelT3-1-" + i}>
                    <span className="indLink" id={"fecha_actual-" + i}>{idioma +  fecha(datos.FECHA_PUBLICACION)}
                    </span>
                  </div>
                </div>
          </div>
          ))
        }
        </>
    );
  }
  else{
    let datos=parametros.datos;
    let id= parametros.id;
    let metodo= parametros.metodo;
    useEffect(() => { 
      if (datos.PROYECTO_TEMA !=="")
        document.getElementById("nivel1-0-" + id).innerHTML=datos.PROYECTO_TEMA;
    }, [datos]);
    return(
        <div className = "col-lg-12 todo" key={"coleccionBuscadorTabulados-" + id} style={{marginBottom:"26px"}} id={"resultadoGeneral-" + id}>
              <div className="col-lg-9 resaltar todoResponsivo" id={"tituloTodo-" + id} style={{display: "inline-flex"}}>
                 <div className="col-lg-10" id={"snippet_titulo-"+ id} style={{textAlign: "justify", display: "inline-flex"}}>
                  {
                    datos.IMAGEN== null || datos.IMAGEN=== "" ? (
                      <a target="_blank" href={datos.URL} id={"snippet_row-"+ i}> 
                        <div onClick={() =>registradatos(datos.TITULO,datos.URL,parametros.metodoBusqueda)} id={"gadget-" + id}>
                          {highlightTexto(datos.TITULO)}
                        </div>
                      </a>
                    ): (
                      <span className="color-tabulador" id={"snippet_row-" + id}>
                        {highlightTexto(datos.TITULO)} 
                      </span>
                    )
                  }
                  </div>
                <div className="col-xs-12 col-md-3 tabulados" style={{textAlign:"center"}} id={"snippet_area-" + id}>
                  <span className=" col-xs-12 col-sm-12 color-tabulador" id={"snippet_area-1-" + id}>
                  {datos.AREAGEOGRAFICA}
                  </span>
                </div>
                <div className="col-xs-12 col-sm-2" id={"snippet_column_periodo-" + id}>
                  <span className=" col-xs-12 col-sm-12 color-tabulador" id={"snippet_row-periodo-" + id}>
                  {datos.PERIODO}
                  </span>
                </div>
                {
                  datos.IMAGEN== null || datos.IMAGEN=== "" ? "": (
                    <div className="col-xs-12 col-sm-1"  style={{paddingRight: "0px", display:"inline-flex", flexDirection:"column", textAlignLast:"right"}} id={"snippet_column_descarga-" + id}>
                      <a target="_blank" href={datos.URL} id={"snippet_row-tag-" + id} onClick={() =>registradatos(datos.TITULO, datos.URL, metodo)}>
                        <img src={datos.IMAGEN}  id={"snippet_row-tag-1-" + id} alt="" /> 
                      </a>
                      <small className=" col-xs-12 col-sm-12" id={"snippet_row-tag-2-" + id}>
                        {datos.TAMANO}
                      </small>
                    </div>
                  )
                }
              </div>
              <div className="col-xs-12 col-sm-7" style={{paddingBottom: "10px"}} id={"nivel1-" + id}>
                <div style={{textAlign: "justify"}} id={"nivel1-0-" + id}>
                </div>
              </div>
              <div className="col-xs-12" id={"nivelT3-" + id}>
                <div className="col-xs-9 formato_fecha" id={"nivelT3-1-" + id}>
                  <span className="indLink" id={"fecha_actual-" + id}>{idioma +  fecha(datos.FECHA_PUBLICACION)}
                  </span>
                </div>
              </div>
        </div>
  );
  }
}
export default BuscadorTabulados;